import React, { useState } from 'react';
import FormulaireAjoutUtilisateursAProjet from './FormulaireAjoutUtilisateursAProjet/FormulaireAjoutUtilisateursAProjet';
import FormulaireSelectionProjetParent from './FormulaireSelectionProjetParent/FormulaireSelectionProjetParent';
import Bouton from '../../UI/Bouton/Bouton';
import FormField from './FormField';
import { stringOrEmptyString } from '../../../ressources/functionJS/stringOrEmptyString';
import { IsArrayString } from '../../../ressources/functionJS/IsArrayString';
import * as requestType from '../../../ressources/glossaires/glossaire_requetes';
import AttenteRequete from '../../../hoc/AttenteRequete/AttenteRequete';
import * as s from '../../../ressources/StyleGlobal/StyleGlobal';
import styles from './Ajouter.module.scss';
import { AiOutlineCheck } from 'react-icons/ai';
import { checkMot } from '../../../ressources/functionJS/checkMot';

const ArrayOrString = (str) => {
  try {
    return JSON.parse(str);
  } catch (e) {
    return str;
  }
};

const AjouterProjet = ({ ajouter }) => {
  // Split state into multiple useState hooks
  const [projectName, setProjectName] = useState('');
  const [parentId, setParentId] = useState(null);
  const [geoBarr, setGeoBarr] = useState('');
  const [groupe, setGroupe] = useState('');
  const [usersList, setUsersList] = useState([]);
  const [description, setDescription] = useState('');
  const [active, setActive] = useState(1);

  const handleFieldChange = (event) => {
    const { name, value } = event.target;
    switch (name) {
      case 'project_name':
        setProjectName(value);
        break;
      case 'groupe':
        setGroupe(value);
        break;
      case 'description':
        setDescription(value);
        break;
      case 'active':
        setActive(parseInt(value));
        break;
      case 'geo_barr':
        setGeoBarr(value);
        break;
      default:
        break;
    }
  };

  const handleParentId = (parentId) => {
    setParentId(parentId);
  };

  const handleUsersList = (utilisateurIdList) => {
    setUsersList(utilisateurIdList);
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    const infoNouveauProjet = {
      project_name: stringOrEmptyString(projectName),
      parent_id: parseInt(parentId),
      geo_barr: IsArrayString(geoBarr, []),
      groupe: stringOrEmptyString(groupe),
      users_list_id: usersList,
      description: stringOrEmptyString(description),
      active: active,
    };
    ajouter(infoNouveauProjet);
  };

  // Form fields configuration
  const formFields = [
    {
      name: 'project_name',
      label: 'project_name',
      placeholder: 'Nom du projet',
      value: projectName,
      required: true,
    },
    {
      name: 'groupe',
      label: 'groupe',
      placeholder: 'groupe',
      value: groupe,
    },
    {
      name: 'description',
      label: 'description_de_projet',
      placeholder: 'description_de_projet',
      value: description,
    },
  ];

  return (
    <div className={styles.ConteneurInfo}>
      <div className={[s.container, s.text_left, styles.Formulaire].join(' ')}>
        <form onSubmit={handleSubmit}>
          {formFields.map((field) => (
            <FormField
              key={field.name}
              name={field.name}
              label={field.label}
              placeholder={field.placeholder}
              value={field.value}
              onChange={handleFieldChange}
              required={field.required}
            />
          ))}

          <div className={s.form_group}>
            <div className={[s.form_row, s.align_items_center].join(' ')}>
              <div className={s.col_12}>
                <FormulaireSelectionProjetParent
                  gererProjetParentId={handleParentId}
                />
              </div>
            </div>
          </div>

          <FormField
            name="active"
            label="etatduproject"
            value={active}
            onChange={handleFieldChange}
            type="select"
            options={[
              { value: 1, label: 'active' },
              { value: 0, label: 'desactive' },
            ]}
          />

          <FormField
            name="geo_barr"
            label="geo_barriere"
            placeholder="geo-barrière"
            value={geoBarr}
            onChange={handleFieldChange}
            validationMessage={
              Array.isArray(ArrayOrString(geoBarr))
                ? null
                : checkMot('format_incorect')
            }
          />

          <FormulaireAjoutUtilisateursAProjet
            gererUtilisateursList={handleUsersList}
          />

          <div className={s.form_group}>
            <div className={[s.d_flex, s.justify_content_between].join(' ')}>
              <div className={styles.btsSty}>
                <AttenteRequete
                  request_type={requestType.creation_d_un_projet}
                  str={checkMot('creation_en_cour')}
                >
                  <Bouton type="submit">
                    <AiOutlineCheck /> {checkMot('creer')}
                  </Bouton>
                </AttenteRequete>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AjouterProjet;
